export default "/images/2fadd3f8e635290355e229170cda21a9.jpg";